import CarouselContainer from "../../Componant/BonusUI/Carousel";

const Carousel = () => {
  return (
    <div className="page-body">
      <CarouselContainer />
    </div>
  );
};

export default Carousel;
